import { ExportExcelHandle } from "./ExportExcel";
import React from "react";
import PaymentPageNavigationFirstLine from "./PaymentPageNavigationFirstLine";
import PaymentPageNavigationSecondLine from "./PaymentPageNavigationSecondLine";

type Props = {
  refExcelExport: ExportExcelHandle | undefined;
};

const ListPageNavigation = ({ refExcelExport }: Props) => {
  return (
    <>
      <PaymentPageNavigationFirstLine refExcelExport={refExcelExport} />
      <PaymentPageNavigationSecondLine />
    </>
  );
};

export default ListPageNavigation;
